import AXIOS from 'axios';
import endpoints from './endpoints.json';
import baseUrl from './baseURL.json';
import firebaseCredentials from './firebaseCredentials.json';
import stripeCredentials from './stripeCredentials.json';
import { uploaderAxios, uploaderBaseUrl } from './uploaderApi';
import { getUploaderToken, clearUploaderToken, isValidJWT } from './tokenManager';
import { processSigninResponse, processProfileResponse, clearAuthTokens, getUserUuid } from './authHelpers';

const getToken = () => localStorage.getItem('token');
const AxiosCancelToken = AXIOS.CancelToken;
const PRODUCTION_Cloud = 'https://Uploader.projector.app/api';
const PRE_PROD_Cloud = 'https://cloud.eq7.in/api';
// eslint-disable-next-line
let STRIPE_PUBLIC_KEY = stripeCredentials.STRIPE_PUBLIC_KEY;
// eslint-disable-next-line
let cloudBaseUrl = PRODUCTION_Cloud;
let selectedBaseUrl = baseUrl.PRODUCTION;
if (window.location.origin.includes('localhost')) {
  selectedBaseUrl = baseUrl.PREPRODUCTION_URL;
  cloudBaseUrl = PRODUCTION_Cloud;
  STRIPE_PUBLIC_KEY = stripeCredentials.STRIPE_PUBLIC_KEY_TEST;
} else if (window.location.origin.includes('dev.app')) {
  selectedBaseUrl = baseUrl.DEVELOPMENT_URL;
  STRIPE_PUBLIC_KEY = stripeCredentials.STRIPE_PUBLIC_KEY_TEST;
  cloudBaseUrl = PRE_PROD_Cloud;
} else if (window.location.origin.includes('preprod')) {
  selectedBaseUrl = baseUrl.PREPRODUCTION_URL;
  cloudBaseUrl = PRE_PROD_Cloud;
  STRIPE_PUBLIC_KEY = stripeCredentials.STRIPE_PUBLIC_KEY_TEST;
}

const axios = AXIOS.create({ baseURL: selectedBaseUrl, method: 'POST' });
axios.interceptors.request.use((req) => {
  if (req?.data instanceof FormData) {
    const formData = req?.data;

    if (formData.has('token')) {
      formData.delete('token');
    }

    formData.append('token', getToken());

    return { ...req, data: formData };
  }

  return { ...req, data: { ...req.data, token: getToken() } };
});

const dataFetcher = (url, data, cancelToken) => axios({
    url,
    ...(data && { data }),
    ...(cancelToken && { cancelToken }),
  }).then((res) => res.data);

const getBaseUrl = () => selectedBaseUrl;
const apiBaseUrl = getBaseUrl();
export {
  axios,
  AxiosCancelToken,
  dataFetcher,
  endpoints,
  getToken,
  apiBaseUrl as baseUrl,
  firebaseCredentials,
  cloudBaseUrl,
  STRIPE_PUBLIC_KEY,
  uploaderAxios,
  uploaderBaseUrl,
  getUploaderToken,
  clearUploaderToken,
  isValidJWT,
  processSigninResponse,
  processProfileResponse,
  clearAuthTokens,
  getUserUuid
};
